import { render, staticRenderFns } from "./orderBtn.vue?vue&type=template&id=693fb5bc"
import script from "./orderBtn.vue?vue&type=script&lang=js"
export * from "./orderBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports